/**
 * Revolut Payment Script
 *
 * This script supports the Revolut payment flows used by the frontend.
 *
 * The primary Delticore/Revolut flow uses Revolut's hosted payment page
 * (redirectType="link") instead of the Revolut Checkout popup.
 *
 * The hosted payment flow is required because the Revolut popup currently
 * supports only card payments, while the hosted payment page supports
 * multiple payment methods, including card, Revolut Pay, Apple Pay and
 * Google Pay.
 *
 * For the hosted payment flow, the script is used by
 * revolutDelticoreRedirect.jsp. The intermediate page creates a browser
 * history entry before navigating to Revolut. When the customer uses the
 * browser Back action, the popstate event redirects the customer to the
 * Delticore failed-payment callback.
 *
 * The popup-based flow is kept below for compatibility with other payment
 * flows that may still use the RevolutCheckout popup API.
 *
 * See:
 * DelticorePaymentServiceProcessorImpl.buildDelticorePaymentRequestData()
 * for the configuration of redirectType.
 */

(function() {
    'use strict';

    const PAYMENT_MONITOR_PREFIX = '[PaymentMonitoring:Revolut] ';

    function logPaymentEvent(eventType, details) {
        const message = PAYMENT_MONITOR_PREFIX + eventType + ' | ' + JSON.stringify(details);
        console.warn(message);
    }

    window.revolutPaymentMonitoring = {
        logPaymentEvent
    };

})();

document.addEventListener('DOMContentLoaded', function () {

    /*
     * ============================================================
     * REVOLUT HOSTED PAYMENT REDIRECT
     * ============================================================
     *
     * Used by revolutDelticoreRedirect.jsp.
     *
     * The intermediate page creates a browser history entry before
     * navigating to the Revolut hosted payment page.
     *
     * When the customer presses the browser Back button, the
     * popstate event redirects the customer to the Delticore
     * failed-payment callback.
     */

    const revolutRedirect = document.getElementById('revolut-redirect');

    if (revolutRedirect) {

        const paymentUrl =
            revolutRedirect.getAttribute('data-payment-url');

        const failedUrl =
            revolutRedirect.getAttribute('data-failed-url');

        if (!paymentUrl || !failedUrl) {

            if (window.revolutPaymentMonitoring) {
                window.revolutPaymentMonitoring.logPaymentEvent(
                    'REDIRECT_CONFIG_ERROR',
                    {
                        paymentUrl: paymentUrl ? 'present' : 'missing',
                        failedUrl: failedUrl ? 'present' : 'missing'
                    }
                );
            }

            return;
        }

        let handlingBack = false;

         /*
         * Create a browser history entry for the intermediate page.
         *
         * This ensures that Browser Back first returns to this page,
         * where the popstate handler can redirect the customer to
         * the Delticore failed-payment callback.
         */
        window.history.pushState(
            {
                revolutPayment: true
            },
            '',
            window.location.href
        );

        window.addEventListener('popstate', function () {

            if (handlingBack) {
                return;
            }

            handlingBack = true;

            if (window.revolutPaymentMonitoring) {
                window.revolutPaymentMonitoring.logPaymentEvent(
                    'BROWSER_BACK',
                    {
                        failedUrl: failedUrl
                    }
                );
            }

            window.location.replace(failedUrl);
        });

        /*
         * Navigate to the Revolut hosted payment page.
         */
        window.location.href = paymentUrl;

        return;
    }


    /*
    * ============================================================
    * LEGACY / POPUP PAYMENT FLOW
    * ============================================================
    *
    * Kept for compatibility with payment flows that use the
    * RevolutCheckout popup API.
    *
    * The Delticore/Revolut hosted payment flow above does not use
    * this popup flow.
    */

    const tokenInput = document.querySelector('input[name="revolutToken"]');
    const orderIdInput = document.querySelector('input[name="orderDOId"]');
    const token = tokenInput ? tokenInput.value : null;
    const orderDOId = orderIdInput ? orderIdInput.value : null;

    async function startRevolutCheckout() {
        if (!token || !orderDOId) {
            if (window.revolutPaymentMonitoring) {
                window.revolutPaymentMonitoring.logPaymentEvent('CONFIG_ERROR', {
                    error: 'Missing Revolut token or orderDOId',
                    token: token ? 'present' : 'missing',
                    orderDOId: orderDOId ? 'present' : 'missing'
                });
            }
            window.location.href = '/delticore/payment/callback/failed/' + orderDOId;
            return;
        }

        try {
            const instance = await RevolutCheckout(token);
            
            instance.payWithPopup({
                onSuccess() {
                    window.location.href =
                        '/delticore/payment/callback/success/' + orderDOId;
                },
                onError(error) {
                    if (window.revolutPaymentMonitoring) {
                        window.revolutPaymentMonitoring.logPaymentEvent('PAYMENT_FAILURE', {
                            orderDOId: orderDOId,
                            error: error.message || String(error),
                            errorType: error.type || 'Unknown'
                        });
                    }
                    window.location.href =
                        '/delticore/payment/callback/failed/' + orderDOId;
                },
                onCancel() {
                    window.location.href =
                        '/delticore/payment/callback/failed/' + orderDOId;
                }
            });

        } catch (e) {
            if (window.revolutPaymentMonitoring) {
                window.revolutPaymentMonitoring.logPaymentEvent('SDK_INIT_ERROR', {
                    orderDOId: orderDOId,
                    error: e.message || String(e),
                    errorType: e.name || 'Unknown'
                });
            }
            window.location.href =
                '/delticore/payment/callback/failed/' + orderDOId;
        }
    }

    if (token) {
        if (typeof RevolutCheckout !== 'undefined') {
            startRevolutCheckout();
        } else {
            const handler = () => startRevolutCheckout();
            window.addEventListener('load', handler, { once: true });
            if (document.readyState === 'complete') {
                handler();
            }
        }
    }

});